import { render, staticRenderFns } from "./SingleValCard.vue?vue&type=template&id=3311f1c8&scoped=true"
import script from "./SingleValCard.vue?vue&type=script&lang=js"
export * from "./SingleValCard.vue?vue&type=script&lang=js"
import style0 from "./SingleValCard.vue?vue&type=style&index=0&id=3311f1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3311f1c8",
  null
  
)

export default component.exports